import { IconButton, styled } from '@mui/material';
import { shouldForwardPropExclude } from '@synergy/utils';

export const AcceptToggle = styled(IconButton, { shouldForwardProp: shouldForwardPropExclude('checked') })<{
    checked?: boolean;
}>(({ theme, checked }) => {
    const backgroundColor = checked ? theme.palette.success.main : theme.palette.grey[200];
    const hoverBackgroundColor = checked ? theme.palette.success.light : theme.palette.success.main;
    const color = checked ? theme.palette.common.white : theme.palette.grey[500];
    const hoverColor = checked ? theme.palette.grey[200] : theme.palette.common.white;

    return {
        width: 24,
        height: 24,
        backgroundColor,

        '&.Mui-disabled': {
            backgroundColor,
        },

        '& svg': {
            color,
        },

        '&:hover': {
            backgroundColor: hoverBackgroundColor,
            '& svg': {
                color: hoverColor,
            },
        },
    };
});
